export const computeBodyTypeURL = ({ key }) => {
    const keyword = key.toLowerCase().split(" ").join("-");
    return [keyword, "cars"];
};
